import { useEffect, useState } from "react";

import { Autocomplete, TextField } from "@mui/material";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  DayLightTimezone,
  CustomPaper,
  StandardTimeZone,
} from "../../Utils/common";

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff !important",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

function TimeZone() {
  const [options, setOptions] = useState([]);
  const [isDaylightSavings, setDaylightSavings] = useState(false);
  const [selectedOption, setSelectedOption] = useState();

  const getDefaultValue = () => {
    const timeZoneList = isDaylightSavings
      ? DayLightTimezone
      : StandardTimeZone;
    if (selectedOption) {
      return timeZoneList.find((timezone) => timezone.label === selectedOption);
    } else {
      const currentTimeZone =
        Intl.DateTimeFormat().resolvedOptions().timeZone === "Asia/Calcutta"
          ? "Asia/Kolkata"
          : Intl.DateTimeFormat().resolvedOptions().timeZone;

      const timezone = timeZoneList.find((timezone) =>
        timezone.label.includes(currentTimeZone)
      );
      return timezone;
    }
  };

  useEffect(() => {
    setOptions(
      isDaylightSavings ? [...DayLightTimezone] : [...StandardTimeZone]
    );
    if (selectedOption) {
      const timeZoneList = isDaylightSavings
        ? DayLightTimezone
        : StandardTimeZone;
      const timezoneKey = selectedOption?.split(" ")?.[1];
      setSelectedOption(
        timeZoneList?.find((timezone) => timezone.label.includes(timezoneKey))
          ?.label
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDaylightSavings]);

  return (
    <div className="dropdown-container">
      <FormControlLabel
        control={
          <IOSSwitch
            sx={{ m: 1 }}
            checked={isDaylightSavings}
            onChange={(e) => setDaylightSavings(e.target.checked)}
          />
        }
        label="Day Light Savings"
      />
      <Autocomplete
        options={options}
        getOptionLabel={(option) => option?.label || ""}
        onChange={(event, newValue) => {
          setSelectedOption(newValue?.label);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Type or select an option"
            variant="standard"
          />
        )}
        defaultValue={getDefaultValue}
        value={options.find((option) => option.label === selectedOption) ?? {}}
        getOptionSelected={(option, value) => {
          return option.label === value.label;
        }}
        PaperComponent={CustomPaper}
      />
    </div>
  );
}

export default TimeZone;
